import React, { FC } from 'react'

import { SideScrollContainer } from '@components/shared/containers/SideScrollContainer'
import Collection from '@models/Collection'
import { CollectionCollectionItem } from '@models/CollectionItem'

import { CollectionCard } from './CollectionCard'

interface CollectionCollectionProps {
  collection: Collection<CollectionCollectionItem>
}

/**
 *
 * Wrapper for a Collection of Collections
 */
export const CollectionCollection: FC<CollectionCollectionProps> = ({
  collection,
}: CollectionCollectionProps): JSX.Element => {
  return (
    <section className="flex flex-col my-5" data-testid={`collection-${collection.id}`}>
      <h1 className="mb-6 text-xl font-semibold md:text-h3">{collection.name}</h1>
      <SideScrollContainer className="-mx-2.5">
        {(collection.items ?? []).map((item) => {
          const key = `item-${item.id}`
          return <CollectionCard item={item} key={key} data-testid={key} />
        })}
      </SideScrollContainer>
    </section>
  )
}
